export default __webpack_public_path__ + "static/assets/b911668ff6158a98a5fc1f0887774b27.svg";